import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import CommonCell from './internal/common-cell';
import OverflowContainer from './internal/overflow-container';
import { indentBase } from './internal/styled';
import withColumnWidth from './internal/with-column-width';
class Cell extends Component {
  render() {
    const {
      children,
      singleLine,
      indentLevel,
      width,
      className,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement(CommonCell, _extends({
      indent: indentLevel ? `calc(${indentBase} * ${indentLevel})` : undefined,
      width: width,
      className: className
    }, props), /*#__PURE__*/React.createElement(OverflowContainer, {
      isSingleLine: singleLine
    }, children));
  }
}
export default withColumnWidth(Cell);